<template>
  <div>
    <div
      class="boxs"
      :style="{
        position: isScroll ? 'fixed' : 'relative',
      }"
      ref="cos"
      id="cos"
    >
      <div
        class="main-top"
        :style="{
          background: mainTopBg,
          color: mainColor,
          filter: showLogo ? '' : 'drop-shadow(2px 4px 6px #78542b7d)',
        }"
        v-if="ifshowmainTopBg"
      >
        <!-- drop-shadow(2px 4px 6px #eee) -->
        <div class="colBox-flex">
          <div>
            <img
              @click="tabCheck(tabList[0], 0)"
              src="@/assets/logo-2.png"
              class="logoImg"
              alt=""
              v-show="showLogo"
            />
            <img
              @click="tabCheck(tabList[0], 0)"
              src="@/assets/logo-1.png"
              class="logoImg"
              alt=""
              v-show="!showLogo"
            />
          </div>
          <div class="colBox">
            <div
              class="colItem"
              :span="6"
              v-for="(item, index) in tabList"
              :key="index"
            >
              <div
                :class="{ 'top-title': true, checked: item.check == true }"
                :style="{ color: item.check == true ? item.myColor : '' }"
                @click="tabCheck(item, index)"
              >
                {{ item.name }}
              </div>
              <transition name="el-zoom-in-center">
                <div class="line" v-show="item.check == true"></div>
              </transition>
            </div>
          </div>
        </div>
        <div class="flexBox">
          <!-- 搜索输入框 -->
          <div
            class="search-block"
            :style="{
              background: searchBg,
            }"
          >
            <img
              v-if="!searchVal"
              class="search-img"
              src="@/assets/new/search.png"
            />
            <input
              :style="{
                background: searchBg,
              }"
              class="search"
              v-model="searchVal"
              placeholder="搜索纪念馆"
              type="text"
              @keyup.enter="onSearch"
            />
            <img
              @click="onClose"
              v-if="searchVal"
              class="search-clean"
              src="@/assets/new/close.png"
            />
            <img
              @click="onSearch"
              v-if="searchVal"
              class="search-click"
              src="@/assets/new/search.png"
            />
          </div>
          <div class="dl-right" @click.stop="toLogin" v-if="!ifshowUser">
            <img class="dl-icon" src="@/assets/dl-icon.png" alt="" />
            <span class="dl-tit">登录</span>
          </div>
          <div class="userBox" v-else>
            <img
              :src="
                userInfo && userInfo.avatarUrl
                  ? userInfo.avatarUrl
                  : 'https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo/user-default.png'
              "
              class="userIcon"
              alt=""
              @mouseenter="showMenu = true"
              @mouseleave="showMenu = false"
            />
            <div class="userName" :style="{ color: mainColor }">个人中心</div>
            <div
              class="userMenu"
              v-show="showMenu"
              @mouseenter="showMenu = true"
              @mouseleave="showMenu = false"
            >
              <div class="userMenu-hidden"></div>
              <div
                class="userMenu-item"
                style="border-bottom: 1px solid #e9e9e9"
                @click="toUser"
              >
                <span class="userMenu-tit">个人中心</span>
              </div>
              <div class="userMenu-item" @click="showLgOut">
                <span class="userMenu-tit">退出登录</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="noticBox" v-if="showLoginOut">
        <div class="notic">
          <div class="notic_title">温馨提示</div>
          <div class="notic_content">是否退出登录?</div>
          <div class="notic_btn">
            <div class="btn_cancle" @click="toCancle">取消</div>
            <div class="btn_confirm" @click="toLoginOut">确定</div>
          </div>
        </div>
        <div class="zhezhao"></div>
      </div>
    </div>
    <div
      :style="{
        position: isScroll ? 'relative' : 'fixed',
      }"
      class="safeArea"
    ></div>
  </div>
</template>

<script>
import { getDate, checkLogin } from "@/api/request";
import { mapState, mapActions } from "vuex";
export default {
  name: "navBars",
  props: {
    tabIndex: {
      type: Number,
      default: 0,
    },
    showLogo: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      isLogin: false,
      isShowSearch: true,
      searchVal: null, //搜索值
      showMenu: false,
      showLoginOut: false,
      // tabIndex: 0,
      tabList: [
        {
          name: "首页",
          check: false,
          url: "/",
          bgColor: "#6C3D0A",
          color: "#fff",
          myColor: "#FFCB7D",
        },
        {
          name: "名人馆",
          check: false,
          url: "/memo?id=1",
          bgColor: "#6C3D0A",
          color: "#fff",
          myColor: "#FFCB7D",
        },
        {
          name: "动漫馆",
          check: false,
          url: "/dimension",
          bgColor: "#fff",
          color: "#6C3D0A",
          myColor: "#FFCB7D",
        },
        {
          name: "家族馆",
          check: false,
          url: "/homeMemo?id=2",
          bgColor: "#6C3D0A",
          color: "#fff",
          myColor: "#FFCB7D",
        },
        {
          name: "私人馆",
          check: false,
          url: "/personal",
          bgColor: "#6C3D0A",
          color: "#fff",
          myColor: "#FFCB7D",
        },
        // {
        //   name: "快速建馆",
        //   check: false,
        //   url: "/venue",
        //   bgColor: "#6C3D0A",
        //   color: "#fff",
        //   myColor: "#FFCB7D",
        // },
        {
          name: "关于我们",
          check: false,
          url: "/contect",
          bgColor: "#6C3D0A",
          color: "#fff",
          myColor: "#FFCB7D",
        },
      ],
      mainTopBg: "#6C3D0A",
      mainColor: "#fff",
      ifshowmainTopBg: true,
      searchBg: "#fff",
      isScroll: false,
    };
  },
  created() {
    if (window.scrollY !== 0) {
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    }
    // this.tabIndex = localStorage.getItem("tabIndex")
    //   ? localStorage.getItem("tabIndex")
    //   : 0;
    // this.tabList.map((e) => {
    //   if (e.url == this.$route.path) {
    //     e.check = true;
    //   }
    // });
    // this.tabList[this.tabIndex].check = true;
    // this.mainTopBg = this.tabList[this.tabIndex].bgColor;
    // this.mainColor = this.tabList[this.tabIndex].color;
  },
  mounted() {
    this.isLogin = localStorage.getItem("token") ? true : false;
    if (this.tabIndex == 99) {
      this.tabList.map((e) => {
        e.check = false;
      });
    } else {
      this.tabList[this.tabIndex].check = true;
    }
    console.log(this.tabList);
    if (!this.showLogo) {
      this.mainTopBg = "#6C3D0A";
      this.mainColor = "#fff";
      this.searchBg = "#fff";
    } else {
      this.mainTopBg = "#fff";
      this.mainColor = "#323232";
      this.searchBg = "#F4F5F7";
    }
    // 添加滚动事件监听器
    window.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      ifshowUser() {
        if (this.$store.getters.token) {
          return true;
        } else {
          return false;
        }
      },
    }),
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 处理滚动事件
      if (window.scrollY == 0) {
        this.isScroll = false;
      } else {
        this.isScroll = true;
      }
    },
    checkLogins() {
      checkLogin().then((res) => {
        if (res.data.result == false) {
          this.$store.commit("REMOVE_TOKEN");
        } else {
        }
      });
    },
    getPage(url, query = {}) {
      this.$router.push({
        path: url,
        query: query,
      });
    },
    toUser() {
      this.showMenu = false;
      this.$router.push({ path: "/user" });
      this.mainTopBg = "#ffffff";
      this.mainColor = "#323232";
      this.tabList.map((item) => {
        return (item.check = false);
      });
    },
    getDate() {
      let data = {
        dictType: 1,
      };
      getDate(data).then((res) => {});
    },
    tabCheck(e, i) {
      if (e.name == "快速建馆") {
        if (!this.isLogin) {
          this.$router.push("login");
          return;
        }
      }
      // this.$refs.carousel.setActiveItem(i);
      if (this.tabList[i].check == true) {
        this.tabList[i].check = false;
      } else {
        this.tabList[i].check = true;
      }
      this.tabList.map((a, j) => {
        if (i != j) {
          this.tabList[j].check = false;
        } else {
          this.tabList[j].check = true;
        }
      });
      if (e.url && e.url != this.$route.path) {
        this.$router.push({ path: e.url });
      }
      this.mainTopBg = e.bgColor;
      this.mainColor = e.color;
      // if (e.check == true) {
      //   this.tabIndex = this.tabList.indexOf(e);
      //   localStorage.setItem("tabIndex", this.tabIndex);
      // }
      // this.showLogo = false;
    },
    toLogin() {
      // this.tabList.map((e, i) => {
      //   if (i == 0) {
      //     e.check = true;
      //     this.mainTopBg = e.bgColor;
      //     this.mainColor = e.color;
      //   } else {
      //     e.check = false;
      //   }
      // });
      this.$router.push({ path: "/login" });
    },
    showLgOut() {
      this.showLoginOut = true;
      this.stopMove();
    },
    toLoginOut() {
      this.showMenu = false;
      this.$store.commit("REMOVE_TOKEN");
      this.showLoginOut = false;
      this.Move();
      this.$router.push({ path: "/" });
    },
    //停止页面滚动
    stopMove() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); //禁止页面滑动
    },
    //开启页面滚动
    Move() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },
    toCancle() {
      this.showLoginOut = false;
      this.Move();
    },
    // 点击搜索
    onSearch() {
      this.$router.push({ path: "/search", query: { val: this.searchVal } });
      this.searchVal = "";
    },

    // 点击清除图片
    onClose() {
      this.searchVal = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.safeArea {
  height: 60px;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  margin: 0 auto;
}
.boxs {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  margin: 0 auto;
  z-index: 999;
}
.flexBox {
  display: flex;
  align-items: center;
}
.botBei {
  height: 105px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.beianImg {
  width: 18px;
  height: 17px;
  margin-left: 61px;
}
.userMenu-tit:hover {
  color: #45796e !important;
}

.search-block {
  width: 240px;
  line-height: 38px;
  position: relative;
  border-radius: 4px;
  cursor: pointer;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 12px;
  box-sizing: border-box;
  margin-right: 36px;
  .search {
    width: 160px;
    border: none;
    height: 38px;
    border-radius: 4px;
    outline: none;
    color: #323232;
    font-size: 14px;
  }
  :focus-visible {
    outline: none;
  }
  .search-img {
    z-index: 9;
    width: 15.25px;
    height: 14.25px;
    margin-right: 12px;
    flex: none;
  }

  .search-clean {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 9px;
    right: 40px;
  }
  .search-click {
    width: 15px;
    height: 15px;
    position: absolute;
    top: 12px;
    right: 12px;
  }
}
.jump-block {
  width: 240px;
  background: #fff;
  line-height: 38px;
  border-radius: 4px;
  display: flex;
  height: 38px;
  cursor: pointer;
  border: 1px solid #f1f1f1;
  .image {
    width: 15px;
    height: 14px;
    margin: 12px;
  }
  span {
    font-size: 14px;
    color: #8f8f9c;
  }
}
.box {
}

.main-top {
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 320px;
  height: 60px;
  background: #6c3d0a;
  color: #fff;
}

.logo-m {
  width: 172.81px;
  height: 52px;
  cursor: pointer;
}

.dl-right {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dl-icon {
  width: 19px;
  height: 19px;
  margin-right: 5px;
  flex: none;
}

.dl-tit {
  color: #ffcb7d;
  font-size: 15px;
  font-weight: 500;
  white-space: pre;
}

.colBox {
  display: flex;
}

.colBox-flex {
  display: flex;
  align-items: center;
}

.logoImg {
  width: 151px;
  height: 39px;
  cursor: pointer;
  flex: none;
  margin-right: 27px;
}

.compTit {
  color: #ffffff;
  padding-right: 64px;
  border-right: 1px solid rgba(255, 255, 255, 0.16);
  letter-spacing: 2px;
  font-size: 16px;
}

.beiTitle {
  margin-left: 5px;
  color: #aaaaaa;
  letter-spacing: 2px;
  font-size: 16px;
}

.beiTitle-1 {
  margin-left: 40px;
  color: #aaaaaa;
  letter-spacing: 2px;
  font-size: 16px;
}

.colItem {
  padding: 0 33px;
  position: relative;
}

.top-title {
  font-size: 16px;
  cursor: pointer;
  white-space: pre;
}

.checked {
  color: #ffcb7d;
  font-weight: 700;
}

.line {
  width: 23.5px;
  height: 4px;
  border-radius: 15px;
  background: #ffcb7d;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  margin-top: 6px;
}

a {
  text-decoration: none;
  color: #999da6;
}

.userIcon {
  width: 32px;
  height: 32px;
  flex: none;
  margin-right: 8px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}

.userName {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  white-space: pre;
}

.userMenu-hidden {
  position: absolute;
  width: 176px;
  height: 20px;
  top: -15px;
  left: 0px;
  background: transparent;
}

.userMenu {
  position: absolute;
  background: #fff;
  border-radius: 10px;
  width: 176px;
  height: 120px;
  top: 47px;
  left: -68px;
  filter: drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.25));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  box-sizing: border-box;
}

.userMenu-item {
  width: 100%;
  height: 50%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.userMenu-tit {
  font-size: 18px;
  cursor: pointer;
  color: #323232;
}
.userBox {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  position: relative;
}

.noticBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  .zhezhao {
    opacity: 0.4;
    background: #000;
    z-index: 9999;
    width: 100%;
    height: 100%;
    position: fixed;
  }

  .notic {
    width: 366px;
    height: 213px;
    border-radius: 10px;
    background: #fff;
    padding: 27px 30px;
    box-sizing: border-box;
    z-index: 10001;

    .notic_title {
      font-size: 20px;
      color: #323232;
      font-weight: 600;
      margin-bottom: 21px;
    }

    .notic_content {
      font-size: 16px;
      color: #323232;
      font-weight: 600;
      margin-bottom: 30px;
    }

    .notic_btn {
      display: flex;
      align-items: center;

      .btn_cancle {
        background: #f4f5f7;
        border-radius: 8px;
        font-size: 17px;
        color: #575757;
        width: 144px;
        height: 48px;
        line-height: 48px;
        margin-right: 18px;
        cursor: pointer;
      }

      .btn_confirm {
        background: #45796e;
        border-radius: 8px;
        font-size: 17px;
        color: #fff;
        width: 144px;
        height: 48px;
        line-height: 48px;
        cursor: pointer;
      }
    }
  }
}
</style>
